document.addEventListener('DOMContentLoaded', function () {
    const readMoreBlocks = document.querySelectorAll('.js-read-more');

    readMoreBlocks.forEach(block => {
        const btn = document.createElement('button');
        btn.className = 'read-more-btn';
        btn.textContent = 'Read more';

        block.after(btn);

        btn.addEventListener('click', () => {
            const isExpanded = block.classList.toggle('expanded');
            btn.textContent = isExpanded ? 'Read less' : 'Read more';
        });
    });
});